import {FormControl, FormHelperText, FormLabel} from "@chakra-ui/react";
import {InputField} from "components/fields/impl/InputField";
import Card from "components/card/Card";
import React from "react";
import {Locale, useLocale} from "utils/Language";

export default function NameInput({value, onChange}) {
    const locale = useLocale()

    return <Card gap={5}>
        <FormControl isRequired>
            <FormLabel fontSize="lg" fontWeight="bold">
                项目名称
            </FormLabel>
            <InputField
                value={value}
                placeholder="请输入文字"
                onChange={({target}) => onChange(target.value)}
            />
            <FormHelperText>
                起个名字吧 (无实际作用)
            </FormHelperText>
        </FormControl>
    </Card>
}